import React from 'react';
import { ErrorPage } from '@/components/error-page';
import { captureRender } from '@/lib/sentry';

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Phase 123 Plan 06 — React render errors are SEV1 (a human was waiting
    // for the UI). captureRender() tags severity=sev1 + service=frontend and
    // sets Sentry level=fatal so the single `severity:sev1` alert rule fires.
    captureRender(error, { componentStack: errorInfo.componentStack ?? undefined });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }
    return this.props.children;
  }
}
